module.exports = __webpack_public_path__ + "media/images/paper_plane-46543b3397da4ec34d9de5b03e4f2abd.svg";